// src/v3/currency/sol.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var CurrencySolIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "CurrencySolIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M2.891 15.686c.13 3.395 2.598 4.454 3.932 4.544h4.37c2.867-.26 4.161-2.467 4.161-4.535 0-1.278-.358-2.327-1.085-3.106-1.274-1.368-3.175-1.388-3.255-1.388H8.137c-1.891-.07-2.976-.849-3.126-2.247-.13-1.269.06-2.238.578-2.857.706-.859 1.861-.859 1.861-.859h3.116c2.598.29 2.708 2.587 2.708 2.857 0 .42.308.749.687.749.378 0 .687-.34.687-.75 0-1.348-.827-3.994-4.022-4.344H7.457c-.105 0-1.772-.005-2.894 1.328-.806.96-1.125 2.318-.935 4.045.11 1.03.766 3.426 4.47 3.566h2.896c.299.01 2.957.11 2.957 2.997 0 .469-.14 2.796-2.837 3.046H6.868c-.156-.015-2.485-.238-2.593-3.106-.01-.42-.369-.75-.717-.72-.388.02-.687.37-.667.78Zm13.638 4.544c.06.02.11.02.17.02h.01c.318 0 .596-.21.676-.53L21.088 4.66a.696.696 0 0 0-.508-.849.693.693 0 0 0-.846.51L16.021 19.38c-.09.38.13.76.508.85Z"
  }
) });

export {
  CurrencySolIcon
};
